export const sessionKeyAfterTrialBigPopupShowTime = 'afterTrialBigPopupShowTime';
export const sessionKeyAfterTrialBigPopupShowCount = 'afterTrialBigPopupShowCount';

export const sessionKeyPushingConnectGLShowTime = 'pushingConnectGLShowTime';
export const sessionKeyPushingConnectGLShowCount = 'pushingConnectGLShowCount';
export const storageKeyPushingConnectGLShowCount = 'pushingConnectGLShowCount';
export const maxShowCountForPushingConnectGLPopup = 10;
